// const { mutations } = require('./app.mutations');
import { Commit, ActionTree, Dispatch } from 'vuex';
import { State } from './app.store';
import * as k8Types from '@/store/modules/k8/k8-types';

import {
  CAPABILITY_APM,
  CAPABILITY_BROWSER,
  CAPABILITY_MOBILE,
  CAPABILITY_DATABASE,
  CAPABILITY_VM,
  CAPABILITY_WSM,
  CAPABILITY_K8M,
  CAPABILITY_SM,
  CAPABILITY_LOG,
  CAPABILITY_MQ,
  CAPABILITY_CLOUD,
  CAPABILITY_DBM,
} from '@/utils/constants';

import { CORRELATED_CAPABILITIES_APM } from '@/utils/constants';
const actions: ActionTree<State, any> = {
  async getGraphData(
    context: {
      commit: Commit;
      dispatch: Dispatch;
      getters: any;
      rootState: any;
      state: any;
    },
    params: {
      index: number;
      duration: any;
      type: string;
      dashboardType: { type: string; isDatabase: boolean };
      isSlow: { type: boolean };
      layoutIndex: number;
      children: { present: boolean; childIndex: number };
      dependency: string;
      service_id: string;
    },
  ) {
    if (context.state.correlatedCapability) {
      switch (context.state.correlatedCapability) {
        case CORRELATED_CAPABILITIES_APM:
          return await context.dispatch(
            'vmState/vmCommonState/getVmGraphData',
            params,
            { root: true },
          );
        default:
          return await context.dispatch('apmState/dashboard/getQuery', params, {
            root: true,
          });
      }
    } else {
      switch (context.state.currentCapability) {
        case CAPABILITY_APM:
          return await context.dispatch('apmState/dashboard/getQuery', params, {
            root: true,
          });
        case CAPABILITY_BROWSER:
          return await context.dispatch(
            'browserState/browserCommonState/getBrowserGraphData',
            params,
            { root: true },
          );
        case CAPABILITY_VM:
          return await context.dispatch(
            'vmState/vmCommonState/getVmGraphData',
            params,
            { root: true },
          );
        case CAPABILITY_MOBILE:
          return await context.dispatch(
            'mobileState/mobileCommonState/getMobileGraphData',
            params,
            { root: true },
          );
        case CAPABILITY_DATABASE:
          return await context.dispatch(
            'databaseState/databaseCommonState/getDatabaseGraphData',
            params,
            { root: true },
          );
        case CAPABILITY_DBM:
          return await context.dispatch(
            'globalState/settings/getCustomDBGraphData',
            params,
            { root: true },
          );
        case CAPABILITY_WSM:
          return await context.dispatch(
            'wsmState/wsmCommonState/getWSMGraphData',
            params,
            { root: true },
          );
        case CAPABILITY_K8M:
          return await context.dispatch(
            `k8State/k8CommonState/getK8GraphData`,
            params,
            { root: true },
          );
        case CAPABILITY_SM:
          return await context.dispatch(
            'syntheticState/applications/getSMGraphData',
            params,
            { root: true },
          );
        case CAPABILITY_LOG:
          return await context.dispatch(
            'logState/logCommonState/getLogGraphData',
            params,
            { root: true },
          );
        case CAPABILITY_MQ:
          return await context.dispatch(
            'mqState/mqCommonState/getMQGraphData',
            params,
            { root: true },
          );
        case CAPABILITY_CLOUD:
          return await context.dispatch(
            'cloudState/detail/getGraphData',
            params,
            { root: true },
          );
        default:
          return await context.dispatch('apmState/dashboard/getQuery', params, {
            root: true,
          });
      }
    }
  },
  async getDataByCapability(
    context: {
      commit: Commit;
      dispatch: Dispatch;
      getters: any;
      rootState: any;
      state: any;
    },
    params: {
      duration: any;
    },
  ) {
    let newparam = {};
    switch (context.state.currentCapability) {
      case CAPABILITY_BROWSER:
        newparam = {
          ...params,
          duration: params.duration,
          keyword: '',
          serviceReq: {
            capability: 'B',
          },
        };
        return await context.dispatch(
          'browserState/browserCommonState/getBrowserData',
          newparam,
          {
            root: true,
          },
        );
      case CAPABILITY_MOBILE:
        newparam = {
          ...params,
          duration: params.duration,
          keyword: '',
          serviceReq: {
            capability: 'M',
          },
        };
        return await context.dispatch(
          'mobileState/mobileCommonState/GET_MOBILE_SERVICES',
          newparam,
          {
            root: true,
          },
        );
      case CAPABILITY_APM:
        newparam = {
          ...params,
          duration: params.duration,
          keyword: '',
          serviceReq: {
            capability: 'A',
          },
        };
        return await context.dispatch(
          'apmState/apmCommonState/getApmData',
          newparam,
          {
            root: true,
          },
        );
      case CAPABILITY_VM:
        newparam = {
          ...params,
          duration: params.duration,
          keyword: '',
          serviceReq: {
            capability: 'V',
          },
        };
        return await context.dispatch(
          'vmState/vmCommonState/getVMData',
          newparam,
          {
            root: true,
          },
        );
      case CAPABILITY_SM:
        newparam = {
          ...params,
          duration: params.duration,
          keyword: '',
          serviceReq: {
            capability: 'S',
          },
        };
        return await context.dispatch(
          'syntheticState/commonState/GET_SYNTHETIC_SERVICES',
          newparam,
          {
            root: true,
          },
        );
      case CAPABILITY_CLOUD:
        return await context.dispatch(
          'cloudState/detail/getGraphData',
          params,
          { root: true },
        );
      default:
        return;
    }
  },
  async toggleForecast(
    context: {
      commit: Commit;
      dispatch: Dispatch;
      getters: any;
      rootState: any;
      state: any;
    },
    data: boolean,
  ) {
    context.commit('setIsForcastEnabled', data);
  },

  async toggleCompareCalendar(
    context: {
      commit: Commit;
      dispatch: Dispatch;
      getters: any;
      rootState: any;
      state: any;
    },
    data: boolean,
  ) {
    context.commit('setIsCompareCalendarEnabled', data);
  },
};

export default actions;
